import { gql } from '@apollo/client';

export const COURCE_SEMESTER_LIST = gql`
  query courseSemesterList($where: course_semester_bool_exp, $order_by: [course_semester_order_by!]) {
    course_semester(where: $where, order_by: $order_by) {
      id
      semester
      course_semester_subjects_subjects {
        subject {
          id
          code
          name
        }
      }
    }
  }
`;

export const COURSE_SEMESTER = gql`
  query courseSemester($where: course_semester_bool_exp, $order_by: [course_semester_order_by!]) {
    course_semester(where: $where, order_by: $order_by) {
      id
      semester
    }
  }
`;
